import mainStyle from "./mainStyle.module.scss";
import React, { useState, useEffect, memo } from 'react';
import { cloneDeep } from "lodash";
import { Typography, Box, TextField, InputAdornment } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show.svg";
import { SolidWarnButton } from "components/buttons/SolidWarnButton";
import { OutlineButton } from "components/buttons/OutlineButton";

// Service
import UserService from 'services/User.service';
import useDataSourceManager from "hooks/useDataSourceManager";

const checkMockup = process.env.REACT_APP_IS_MOCKUP;

const ModalforConfirmPw = (props) => {
  const {
    title, content, 
    cancelBtn, saveBtn,
    setOpenModal,
    originUser, onBottonClick
  } = props;
  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } = useDataSourceManager();

  const[userInfo, setUserInfo] = useState(null)

  const [inputPw, setInputPw] = useState('')
  const [checkResponse, setCheckResponse] = useState('')

  const handleBack = () => {
    onBottonClick('close')
    setOpenModal(false);
  };

  const handleNext = () => {
    // console.log(currntType, currntStep)
    let tmpUser = cloneDeep(userInfo)
    tmpUser.password = inputPw;
    if(checkMockup === "true"){
      onBottonClick('ok')
      setOpenModal(false);
    }else{
      checkUserPw(tmpUser)
    }
  }

  const checkUserPw = async(updateUser) => {
    const response = await sendRequest("casdoor/UserService/.checkUserPassword",
      null, null, updateUser
    );
    // const response = await UserService.checkUserPassword(updateUser, token)

    setCheckResponse(response)
    if(response.status === 'ok'){
      onBottonClick('ok')
      setOpenModal(false);
    }
  }

  const [currentPw, setCurrentPw] = useState('')
  const [ifNgCurrentPw, setIfNgCurrentPw] = useState(false)
  const [currentPwErr, setCurrentPwErr] = useState('')
  const [showCurrentPw, setShowCurrentPw] = useState(false)

  const handleCurrentPw = (e) => {
    let tmpVal = e.target.value;
    setCurrentPw(tmpVal)
    setInputPw(tmpVal)
  }
  const handleShowCurrentPw = (e) => {
    let tmpVal = showCurrentPw;
    setShowCurrentPw(!tmpVal)
  }

  const replaceVariableMsg = (originMsg, target, replaceAry) =>{
    let index = 0;

    // 對 target 進行正則轉譯
    // function escapeRegExp(string) {
    //   return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // }
    // escapeRegExp(target);
    const escapedTarget = target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const targetRegex = new RegExp(escapedTarget, 'g');

    return originMsg.replace(targetRegex, () => {
      return index < replaceAry.length ? replaceAry[index++] : target;
    });
  }

  useEffect(() => {
    if (checkResponse.status === "error") {
      setIfNgCurrentPw(true);
      setCurrentPwErr("The password you entered is incorrect. Please try again.");
    } else {
      setIfNgCurrentPw(false);
      setCurrentPwErr("");
    }
  }, [checkResponse]);

  useEffect(() => {
    setUserInfo(originUser)
  }, []);

  return (
    <>
      <div className={mainStyle['modal_Block']} style={{margin:'10px 0px 20px 0px'}}>
        {title &&
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            {title}
          </Typography>
        }
        {/* <IconButton style={newOpenTheme} onClick={handleClose}>
          <img src={close} alt="openInNew" width={"25px"} />
        </IconButton> */}
      </div>
      <Box style={{marginBottom:'10px'}}>
        <div className={mainStyle['modal_rows']}>
          <div className={mainStyle['modal_Block']}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[3],
                fontFamily: theme.typography.fontFamily,
              }}
              >
              {content}
            </Typography>
          </div>
        </div>
        <div className={mainStyle['modal_rows']}>
          <TextField
            error={ifNgCurrentPw}
            value={currentPw}
            fullWidth
            placeholder=""
            type={showCurrentPw? 'text': 'password'}
            size="small"
            onChange={(e) => handleCurrentPw(e)}
            variant="outlined"
            sx={{
              mr: 1,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px', // 改變圓角
                '& fieldset': {
                  borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                },
                "&:hover fieldset": {
                  borderColor: theme.palette.primary.mainHover,
                },
                "&.Mui-focused fieldset": {
                  border: '1px solid',
                  borderColor: theme.palette.primary.main,
                },
              },
            }}
            inputProps={{style: {fontSize: '13px'}}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {!showCurrentPw && <HideIcon onClick={handleShowCurrentPw} style={{cursor:'pointer'}}/>}
                  {showCurrentPw && <ShowIcon onClick={handleShowCurrentPw} style={{cursor:'pointer'}}/>}
                </InputAdornment>
              ),
            }}
            style={{margin:'5px 0px'}}
          />
          {currentPwErr && 
            <Typography
              sx={{
                color: theme.palette.primary.redPrimary,
                fontSize: theme.typography.customFontSize[3],
                fontFamily: theme.typography.fontFamily,
              }}
              >
              {currentPwErr}
            </Typography>
          }
        </div>
      </Box>
      <div className={mainStyle['modal_Block']}>
        {cancelBtn && <Box style={{margin: '10px'}}>
          <OutlineButton width="135px" height="42px" onClick={handleBack}>
          {cancelBtn}
          </OutlineButton>
        </Box>}
        {saveBtn && <Box style={{margin: '10px'}}>
          <SolidWarnButton width="135px" height="42px" onClick={handleNext}>
            {saveBtn}
          </SolidWarnButton>
        </Box>}
      </div>
    </>
  );
}

export default memo(ModalforConfirmPw);